import { useState } from "react";

const ShareModal = ({ open, onClose, title, url, description }) => {
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const encUrl = encodeURIComponent(url);
  const encTitle = encodeURIComponent(title || "Bundeli Chugli");
  const encText = encodeURIComponent(
    (title ? title + " - " : "") + "Bundeli Chugli"
  );

  const links = [
    {
      name: "WhatsApp",
      href: `https://api.whatsapp.com/send?text=${encText}%20${encUrl}`,
      icon: "fab fa-whatsapp",
      color: "bg-green-500",
    },
    {
      name: "Facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${encUrl}`,
      icon: "fab fa-facebook-f",
      color: "bg-blue-600",
    },
    {
      name: "X",
      href: `https://twitter.com/intent/tweet?url=${encUrl}&text=${encTitle}`,
      icon: "fab fa-x-twitter",
      color: "bg-black",
    },
    {
      name: "Telegram",
      href: `https://t.me/share/url?url=${encUrl}&text=${encTitle}`,
      icon: "fab fa-telegram-plane",
      color: "bg-sky-500",
    },
  ];

  const handleCopy = async () => {
    const textToCopy = title ? `${title}\n${url}` : url;
    try {
      await navigator.clipboard.writeText(textToCopy);
    } catch (_) {
      const ta = document.createElement("textarea");
      ta.value = textToCopy;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-gray-900">Share</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 transition"
            aria-label="Close"
          >
            <i className="fa-solid fa-xmark text-xl"></i>
          </button>
        </div>

        <div className="grid grid-cols-4 gap-3 mb-5">
          {links.map((l) => (
            <a
              key={l.name}
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center gap-2"
            >
              <span
                className={`${l.color} text-white w-12 h-12 rounded-full flex items-center justify-center shadow hover:scale-110 transition`}
              >
                <i className={`${l.icon} text-xl`}></i>
              </span>
              <span className="text-xs text-gray-600">{l.name}</span>
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <input
            readOnly
            value={url}
            className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-700 bg-gray-50"
            onFocus={(e) => e.target.select()}
          />
          <button
            onClick={handleCopy}
            className="bg-red-600 text-white text-sm font-semibold px-4 py-2 rounded-lg hover:bg-red-700 transition whitespace-nowrap"
          >
            {copied ? "Copied!" : "Copy"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;